export default "__VITE_ASSET__COQOhP1N__"